import React, { Component } from "react";
import { SelectButton } from "primereact/selectbutton";
import { Growl } from "primereact/growl";
import { Messages } from "primereact/messages";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import subMonths from "date-fns/subMonths";
import { InputText } from "primereact/inputtext";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";
import axios from "axios";
import * as appConst from "../../../Common/constants";
import { Dropdown } from "primereact/dropdown";
import * as helper from "../../../Common/Helper";

class Account extends Component {
  constructor(props) {
    super(props);

    var currentTime = new Date();

    this.state = {
      dateClass: "collapse",
      monthClass: "collapse",
      yearClass: "collapse",
      fromYear: "",
      toYear: "",
      type: "",
      fromDate: "",
      toDate: "",
      fromMonth: null,
      toMonth: null,
      accounts: [],
      chStatus: "",
      receiptFromMonth: new Date(
        currentTime.getFullYear(),
        currentTime.getMonth(),
        1
      ),
      receiptToMonth: new Date(
        currentTime.getFullYear(),
        currentTime.getMonth() + 1,
        0
      )
    };
  }

  componentDidMount() {
    if (this.props.reportType === "Monthly") {
      this.setState({
        typeClass: "collapse",
        daybookFilterClass: "collapse",
        receiptFilterClass: "collapse",
        monthFilterClass: "row p-1 border",
        receiptListClass: "collapse",
        chequeClass: "collapse"
      });
    } else if (this.props.reportType === "DayBook") {
      this.setState({
        typeClass: "collapse",
        daybookFilterClass: "row p-1 border",
        monthFilterClass: "collapse",
        receiptFilterClass: "collapse",
        receiptListClass: "collapse",
        chequeClass: "collapse"
      });
    } else if (this.props.reportType === "Receipt") {
      this.setState({
        typeClass: "collapse",
        daybookFilterClass: "collapse",
        monthFilterClass: "collapse",
        receiptFilterClass: "row p-1 border",
        receiptListClass: "row p-1 border",
        chequeClass: "collapse"
      });
    } else if (this.props.reportType === "Cheque") {
      this.setState({
        typeClass: "collapse",
        daybookFilterClass: "collapse",
        monthFilterClass: "collapse",
        receiptFilterClass: "collapse",
        receiptListClass: "collapse",
        chequeClass: "row p-1 border"
      });
    } else {
      this.setState({
        typeClass: "row p-1 border",
        monthFilterClass: "collapse",
        daybookFilterClass: "collapse",
        receiptFilterClass: "collapse",
        receiptListClass: "collapse",
        chequeClass: "collapse"
      });
    }
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  };

  render() {
    const FILTER = [
      { label: "Date", value: "Date" },
      { label: "Month", value: "Month" },
      { label: "Year", value: "Year" }
    ];

    const ChequeStatus = [
      { label: "All", value: "All" },
      { label: "Pending", value: "Pending" },
      { label: "Cleared", value: "Cleared" }
    ];

    //https://reactdatepicker.com/
    return (
      <div>
        <h3 align="center">{this.props.reportType} Report</h3>
        <div>
          <div className="container-fluid" />
          <div className={this.state.typeClass}>
            <div className="col col-md-2">Report Type</div>
            <div className="col col-md-4">
              <SelectButton
                value={this.state.type}
                options={FILTER}
                onChange={this.onTypeChange}
                className="p-error"
              />
            </div>
          </div>

          <div className={this.state.monthFilterClass}>
            <div className="col col-md-2 ">Month</div>
            <div className="col col-md-3">
              <DatePicker
                selected={this.state.fromMonth}
                onChange={e => {
                  this.setState({ fromMonth: e });
                }}
                dateFormat="MMM-yyyy"
                showMonthYearPicker
              />
            </div>
          </div>
          <div className={this.state.receiptFilterClass}>
            <div className="col col-md-2 ">From Month</div>
            <div className="col col-md-3">
              <DatePicker
                selected={this.state.receiptFromMonth}
                onChange={e => {
                  this.setState({ receiptFromMonth: e });
                }}
                dateFormat="MMM-yyyy"
                showMonthYearPicker
              />
            </div>
            <div className="col col-md-2">To Month</div>
            <div className="col col-md-3">
              <DatePicker
                selected={this.state.receiptToMonth}
                onChange={e => this.setState({ receiptToMonth: e })}
                dateFormat="MMM-yyyy"
                showMonthYearPicker
              />
              &nbsp;&nbsp;
              <button
                onClick={this.onFilterClick}
                className="btn btn-primary btn-md mr-2"
              >
                Filter
              </button>
            </div>
          </div>
          <div className={this.state.receiptListClass}>
            <div
              className="ag-theme-blue col col-md-12"
              style={this.getHeight()}
            >
              <AgGridReact
                rowData={this.state.accounts}
                pagination={true}
                sorting={true}
                filter={true}
                onGridReady={this.onGridReady}
                paginationAutoPageSize={true}
                rowSelection="multiple"
              >
                <AgGridColumn field="_id" hide="true" />
                <AgGridColumn
                  width={50}
                  checkboxSelection
                  filter={false}
                  resizable
                />
                <AgGridColumn
                  field="receiptNo"
                  headerName="Receipt No"
                  width={130}
                  sortable
                  resizable
                  filter
                />
                <AgGridColumn
                  field="txndate"
                  headerName="Date"
                  width={120}
                  sortable
                  resizable
                  filter
                  valueFormatter={helper.dateFormatter}
                />
                <AgGridColumn
                  field="desc"
                  headerName="Description"
                  width={150}
                  sortable
                  resizable
                  filter
                />
                <AgGridColumn
                  field="type"
                  headerName="Type"
                  width={150}
                  sortable
                  resizable
                  filter
                />
                <AgGridColumn
                  field="txntype"
                  headerName="Receipt / Voucher"
                  width={170}
                  sortable
                  resizable
                  filter
                  valueFormatter={this.receiptFormatter}
                />

                <AgGridColumn
                  field="amount"
                  headerName="Amount"
                  width={150}
                  sortable
                  resizable
                  filter
                  valueFormatter={this.currencyFormatter}
                //cellStyle={this.incomeColor}
                />
              </AgGridReact>
            </div>
          </div>
          <div className={this.state.daybookFilterClass}>
            <div className="col col-md-2 ">Date</div>
            <div className="col col-md-4">
              <DatePicker
                selected={this.state.fromDate}
                onChange={e => this.setState({ fromDate: e })}
                dateFormatCalendar={"MMM yyyy"}
                minDate={subMonths(new Date(), 12)}
                maxDate={new Date()}
                showMonthYearDropdown
                dateFormat="dd-MMM-yyyy"
                width="300px"
              />
            </div>
          </div>
          <div className={this.state.dateClass}>
            <div className="col col-md-2">From Date</div>
            <div className="col col-md-3">
              <DatePicker
                selected={this.state.fromDate}
                onChange={e => this.setState({ fromDate: e })}
                dateFormatCalendar={"MMM yyyy"}
                minDate={subMonths(new Date(), 12)}
                maxDate={new Date()}
                showMonthYearDropdown
                dateFormat="dd-MMM-yyyy"
                width="300px"
              />
            </div>
            <div className="col col-md-2">To Date</div>
            <div className="col col-md-3">
              <DatePicker
                selected={this.state.toDate}
                onChange={e => this.setState({ toDate: e })}
                dateFormatCalendar={"MMM yyyy"}
                minDate={subMonths(new Date(), 12)}
                maxDate={new Date()}
                showMonthYearDropdown
                dateFormat="dd-MMM-yyyy"
                width="300px"
              />
            </div>
          </div>
          <div className={this.state.monthClass}>
            <div className="col col-md-2">From Month</div>
            <div className="col col-md-3">
              <DatePicker
                selected={this.state.fromMonth}
                onChange={e => this.setState({ fromMonth: e })}
                dateFormat="MMM-yyyy"
                showMonthYearPicker
              />
            </div>
            <div className="col col-md-2">To Month</div>
            <div className="col col-md-3">
              <DatePicker
                selected={this.state.toMonth}
                onChange={e => this.setState({ toMonth: e })}
                dateFormat="MMM-yyyy"
                showMonthYearPicker
              />
            </div>
          </div>
          <div className={this.state.yearClass}>
            <div className="col col-md-2">From Year (YYYY)</div>
            <div className="col col-md-3">
              <InputText
                type="text"
                value={this.state.fromYear}
                onChange={e => this.setState({ fromYear: e.target.value })}
              />
            </div>
            <div className="col col-md-2">Enter To Year (YYYY)</div>
            <div className="col col-md-3">
              <InputText
                type="text"
                value={this.state.toYear}
                onChange={e => this.setState({ toYear: e.target.value })}
              />
            </div>
          </div>
          <div className={this.state.chequeClass}>
            <div className="col col-md-2 ">Status</div>
            <div className="col col-md-3">
              <Dropdown
                value={this.state.chStatus}
                options={ChequeStatus}
                placeholder="Select Status"
                onChange={e => this.setState({ chStatus: e.target.value })}
              />
            </div>
          </div>

          <div className="row p-1 border">
            <button
              onClick={this.onGenerateClick}
              className="btn btn-primary btn-md mr-2"
            >
              Generate Report
            </button>
          </div>
          <Messages ref={el => (this.messages = el)} />
          <Growl ref={el => (this.growl = el)} />
        </div>
      </div>
    );
  }

  getHeight() {
    var hgt = window.innerHeight - 160;
    return { height: hgt + "px" };
  }

  currencyFormatter(params) {
    var parts = (params.value < 0 ? params.value * -1 : params.value)
      .toString()
      .split(".");
    return (
      parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      (parts[1] ? "." + parts[1] : ".00")
    );
  }

  receiptFormatter(params) {
    return params.value === "Income" ? "Receipt" : "Voucher";
  }

  onFilterClick = e => {
    const obj = {
      fromDate: this.state.receiptFromMonth,
      toDate: new Date(
        this.state.receiptToMonth.getFullYear(),
        this.state.receiptToMonth.getMonth() + 1,
        0
      )
    };

    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/account/receipts",
        obj
      )
      .then(response => {
        this.setState({ accounts: response.data });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  onGenerateClick = e => {
    e.preventDefault();

    if (this.props.reportType === "Monthly") {
      if (
        this.state.fromMonth === "" ||
        this.state.fromMonth === null
      ) {
        this.messages.show({
          severity: "error",
          summary: "Error !!",
          detail: "Select Month !!"
        });
      } else {
        this.state.fromDate = this.state.fromMonth;
        this.state.toDate = new Date(
          this.state.fromMonth.getFullYear(),
          this.state.fromMonth.getMonth() + 1,
          0
        );
        const obj = {
          fromDate: this.state.fromDate,
          toDate: this.state.toDate
        };

        this.props.onClick(this.props.reportType, obj);
      }
    } else if (this.props.reportType === "Receipt") {
      const selectedNodes = this.gridApi.getSelectedNodes();
      const selectedData = selectedNodes.map(node => node.data);
      const selectedDataStringPresentation = selectedData
        .map(node => node._id)
        .join(",");

      const ip = {
        count: selectedNodes.length,
        ids: selectedDataStringPresentation
      };

      if (selectedNodes.length > 0) {
        this.props.onClick(this.props.reportType, ip);
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "Select Entry !!"
        });
      }
    } else if (this.props.reportType === "DayBook") {
      if (this.state.fromDate === "") {
        this.messages.show({
          severity: "error",
          summary: "Error !!",
          detail: "Select Date !!"
        });
      } else {
        const obj = {
          fromDate: this.state.fromDate
        };

        this.props.onClick(this.props.reportType, obj);
      }
    } else if (this.props.reportType === "Cheque") {
      if (this.state.chStatus === "") {
        this.messages.show({
          severity: "error",
          summary: "Error !!",
          detail: "Select Status !!"
        });
      } else {
        const obj = {
          status: this.state.chStatus
        };

        this.props.onClick(this.props.reportType, obj);
      }
    } else {
      if (this.state.type === "Date") {
        if (this.state.fromDate === "" || this.state.toDate === "") {
          this.messages.show({
            severity: "error",
            summary: "Error !!",
            detail: "Select Date !!"
          });
        } else {
          const obj = {
            type: this.state.type,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate
          };
          this.props.onClick(this.props.reportType, obj);
        }
      } else if (this.state.type === "Month") {
        if (
          this.state.fromMonth === "" ||
          this.state.fromMonth === null ||
          this.state.toMonth === "" ||
          this.state.toMonth === null
        ) {
          this.messages.show({
            severity: "error",
            summary: "Error !!",
            detail: "Select Month !!"
          });
        } else {
          this.state.fromDate = this.state.fromMonth;
          this.state.toDate = new Date(
            this.state.toMonth.getFullYear(),
            this.state.toMonth.getMonth() + 1,
            0
          );
          const obj = {
            type: this.state.type,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate
          };

          this.props.onClick(this.props.reportType, obj);
        }
      } else if (this.state.type === "Year") {
        if (this.state.fromYear === "" || this.state.toYear === "") {
          this.messages.show({
            severity: "error",
            summary: "Error !!",
            detail: "Enter Year !!"
          });
        } else {
          this.state.fromDate = new Date(this.state.fromYear, 0, 1);
          this.state.toDate = new Date(this.state.toYear, 11, 31);

          const obj = {
            type: this.state.type,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate
          };

          this.props.onClick(this.props.reportType, obj);
        }
      } else {
        this.messages.show({
          severity: "error",
          summary: "Error !!",
          detail: "Select Report Type"
        });
      }
    }
  };

  onTypeChange = e => {
    this.setState({ type: e.value });

    switch (e.value) {
      case "Date":
        this.setState({
          dateClass: "row p-1 border",
          monthClass: "collapse",
          yearClass: "collapse"
        });
        break;
      case "Month":
        this.setState({
          dateClass: "collapse",
          monthClass: "row p-1 border",
          yearClass: "collapse"
        });
        break;
      case "Year":
        this.setState({
          dateClass: "collapse",
          monthClass: "collapse",
          yearClass: "row p-1 border"
        });
        break;
      default:
        this.setState({
          dateClass: "collapse",
          monthClass: "collapse",
          yearClass: "collapse"
        });
    }
  };
}

export default Account;
